import PeriodTranslation from 'src/models/period/interfaces/PeriodTranslation'

export default class StaticTranslatable implements PeriodTranslation {
  key: string
  translationKey: string
  interpolations: Record<string, unknown>

  constructor(
    key: string,
    translationKey: string,
    interpolations: Record<string, unknown> = {},
  ) {
    this.key = key
    this.translationKey = translationKey
    this.interpolations = interpolations
  }
}
